import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import SettingsModal from './SettingsModal';
import { FaKaaba } from 'react-icons/fa';
import QiblaFinderModal from './QiblaFinderModal';

// inline icons
const HiLocationMarker = (props) => (
  <svg
    {...props}
    xmlns='http://www.w3.org/2000/svg'
    fill='currentColor'
    viewBox='0 0 20 20'
  >
    <path
      fillRule='evenodd'
      d='M10 2a6 6 0 00-6 6c0 4.478 4.793 9.774 5.485 10.515a.75.75 0 001.03 0C11.207 17.774 16 12.478 16 8a6 6 0 00-6-6zm0 
      8a2 2 0 100-4 2 2 0 000 4z'
      clipRule='evenodd'
    />
  </svg>
);

const HiClock = (props) => (
  <svg
    {...props}
    xmlns='http://www.w3.org/2000/svg'
    fill='currentColor'
    viewBox='0 0 20 20'
  >
    <path
      fillRule='evenodd'
      d='M10 18a8 8 0 100-16 8 8 0 000 16zM9.5 7a.5.5 0 
      00-1 0v5.5a.5.5 0 00.5.5h4a.5.5 0 000-1h-3V7z'
      clipRule='evenodd'
    />
  </svg>
);

const HiArrowNarrowRight = (props) => (
  <svg
    {...props}
    xmlns='http://www.w3.org/2000/svg'
    fill='currentColor'
    viewBox='0 0 20 20'
  >
    <path
      fillRule='evenodd'
      d='M10.293 3.293a1 1 0 011.414 0l6 
      6a1 1 0 010 1.414l-6 6a1 1 0 
      01-1.414-1.414L14.586 11H3a1 1 0 
      110-2h11.586l-4.293-4.293a1 1 0 
      010-1.414z'
      clipRule='evenodd'
    />
  </svg>
);

const HiSun = (props) => (
  <svg
    {...props}
    xmlns='http://www.w3.org/2000/svg'
    fill='currentColor'
    viewBox='0 0 20 20'
  >
    <path
      fillRule='evenodd'
      d='M10 2a.75.75 0 01.75.75v1.5a.75.75 
      0 01-1.5 0v-1.5A.75.75 
      0 0110 2zM4.685 4.685a.75.75 0 
      011.06 0l1.06 1.06a.75.75 0 
      01-1.06 1.06l-1.06-1.06a.75.75 0 
      010-1.06zm10.63 0a.75.75 0 
      010 1.06l-1.06 1.06a.75.75 0 
      01-1.06-1.06l1.06-1.06a.75.75 0 
      011.06 0zM10 16a.75.75 0 
      01-.75-.75v-1.5a.75.75 0 
      011.5 0v1.5a.75.75 0 
      01-.75.75zM3.204 
      9.388a.75.75 0 
      01.706-.593h12.18c.277 0 
      .524.18.593.456l.004.015a.75.75 0 
      01-.593.706l-.015.004H3.882a.75.75 0 
      01-.706-.593l-.004-.015a.75.75 0 
      01.593-.706zM3.975 14.685a.75.75 0 
      011.06 0l1.06 1.06a.75.75 0 
      01-1.06 1.06l-1.06-1.06a.75.75 0 
      010-1.06zm10.63 0a.75.75 0 
      011.06 0l1.06 1.06a.75.75 0 
      11-1.06 1.06l-1.06-1.06a.75.75 0 
      010-1.06z'
      clipRule='evenodd'
    />
  </svg>
);

const HiMoon = (props) => (
  <svg
    {...props}
    xmlns='http://www.w3.org/2000/svg'
    fill='currentColor'
    viewBox='0 0 20 20'
  >
    <path
      d='M7 2a.75.75 0 00-.75.75c0 1.543.376 3.072 
    1.15 4.453l-.973.848a.75.75 0 
    00.58 1.378l2.973-1.487A7.5 7.5 
    0 0116.75 16h-.75a.75.75 0 
    000 1.5h.75a.75.75 0 
    00.75-.75A8.5 8.5 0 007 
    2.75V2z'
    />
  </svg>
);

const HiCloud = (props) => (
  <svg
    {...props}
    xmlns='http://www.w3.org/2000/svg'
    fill='currentColor'
    viewBox='0 0 20 20'
  >
    <path
      fillRule='evenodd'
      d='M5.5 8.75a.75.75 0 
      000 1.5h1.25V12a.75.75 0 
      001.5 0v-1.75H12a.75.75 
      0 000-1.5h-3.75V5.5a.75.75 
      0 00-1.5 0v2.5H5.5zM15 
      10a5 5 0 11-5-5 5 5 0 
      015 5z'
      clipRule='evenodd'
    />
  </svg>
);

const HiMap = (props) => (
  <svg
    {...props}
    xmlns='http://www.w3.org/2000/svg'
    fill='currentColor'
    viewBox='0 0 20 20'
  >
    <path
      fillRule='evenodd'
      d='M10.244 3.012a.75.75 0 
      00-.488 0l-5 2.25A.75.75 
      0 004 6.015v11.235a.75.75 
      0 00.999.734l5.25-1.5a.75.75 
      0 00.49.006l5.25 1.5a.75.75 
      0 001.01-.734V6.015a.75.75 
      0 00-.756-.753l-5-2.25zM10.5 
      5.163l4 1.8V16.63L10.5 
      15.4V5.163zM5.5 6.965l4-1.8v10.707l-4 
      1.144V6.965z'
      clipRule='evenodd'
    />
  </svg>
);

// API
const PRAYER_API_URL = 'https://api.aladhan.com/v1/timings';
const STORED_LOCATION_KEY = 'prayerAppLastLocation';
const PREFS_KEY = 'prayerReminderPrefs';
const DEMO_LAT = 41.0082;
const DEMO_LON = 28.9784;

// defaults
const DEFAULT_PREFS = {
  enabled: true,
  minutesBefore: 30,
  sound: true,
  voice: false,
};

const formatTimeRemaining = (ms) => {
  if (ms <= 0) return '00m 00s';
  let sec = Math.floor(ms / 1000);
  const h = Math.floor(sec / 3600);
  sec %= 3600;
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  const pad = (n) => String(n).padStart(2, '0');
  return `${h > 0 ? `${h}h ` : ''}${pad(m)}m ${pad(s)}s`;
};

const getNextPrayerWithRemainingTime = (timings) => {
  const now = new Date();
  const today = now.toDateString();
  const prayers = [
    { name: 'Fajr', time: timings.Fajr },
    { name: 'Sunrise', time: timings.Sunrise },
    { name: 'Dhuhr', time: timings.Dhuhr },
    { name: 'Asr', time: timings.Asr },
    { name: 'Maghrib', time: timings.Maghrib },
    { name: 'Isha', time: timings.Isha },
  ];
  for (const p of prayers) {
    const when = new Date(`${today} ${p.time}:00`);
    const remainingMs = when.getTime() - now.getTime();
    if (remainingMs > 0) return { name: p.name, time: p.time, remainingMs };
  }
  const tomorrow = new Date(now);
  tomorrow.setDate(now.getDate() + 1);
  const tDate = tomorrow.toDateString();
  const fajr = new Date(`${tDate} ${timings.Fajr}:00`);
  return { name: 'Fajr', time: timings.Fajr, remainingMs: fajr - now };
};

export default function PrayerTimeLanding() {
  const [timings, setTimings] = useState(null);
  const [locationName, setLocationName] = useState('Unknown');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const audioRef = useRef(null);
  const [isQiblaOpen, setIsQiblaOpen] = useState(false);
  const [manualInput, setManualInput] = useState('');
  const [isManualEntryNeeded, setIsManualEntryNeeded] = useState(false);
  const [timeRemainingMs, setTimeRemainingMs] = useState(0);
  const [nextPrayer, setNextPrayer] = useState(null);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  const [prefs, setPrefs] = useState(() => {
    try {
      const saved = JSON.parse(localStorage.getItem(PREFS_KEY));
      const valid = [30, 45, 60];
      let m = Number(saved?.minutesBefore);
      if (!valid.includes(m)) m = DEFAULT_PREFS.minutesBefore;
      return { ...DEFAULT_PREFS, ...saved, minutesBefore: m };
    } catch {
      return DEFAULT_PREFS;
    }
  });

  const timersRef = useRef([]);
  const hasAttemptedGeolocation = useRef(false);
  const navigate = useNavigate();

  // save prefs
  useEffect(() => {
    localStorage.setItem(PREFS_KEY, JSON.stringify(prefs));
  }, [prefs]);

  // ask permission
  useEffect(() => {
    if (!prefs.enabled) return;
    if ('Notification' in window && Notification.permission === 'default') {
      Notification.requestPermission().catch(() => {});
    }
  }, [prefs.enabled]);

  // load sound
  useEffect(() => {
    audioRef.current = new Audio('/ding.mp3');
    audioRef.current.volume = 1.0;
  }, []);

  const playSound = useCallback(() => {
    if (!prefs.sound || !audioRef.current) return;
    try {
      audioRef.current.pause();
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch(() => {});
    } catch {}
  }, [prefs.sound]);

  const speak = useCallback(
    (text) => {
      if (!prefs.voice) return;
      try {
        const u = new SpeechSynthesisUtterance(text);
        u.lang = 'en-US';
        window.speechSynthesis.speak(u);
      } catch {}
    },
    [prefs.voice],
  );

  // Fallback local timers ONLY when FCM token is NOT saved
  const scheduleReminders = useCallback(
    (t) => {
      timersRef.current.forEach(clearTimeout);
      timersRef.current = [];

      if (!t || !prefs.enabled) return;

      const hasServerReminders = !!localStorage.getItem('azan:fcmKey');
      if (hasServerReminders) {
        console.log('☁ Using FCM server reminders — skipping local timers.');
        return;
      }

      const msBefore = Number(prefs.minutesBefore) || 30;
      const skip = new Set(['Sunrise']);
      const today = new Date().toDateString();

      Object.entries(t).forEach(([name, time]) => {
        if (skip.has(name)) return;

        const prayerTime = new Date(`${today} ${time}:00`);
        const remindTime = new Date(prayerTime.getTime() - msBefore * 60000);
        const delay = remindTime - Date.now();

        if (delay > 0) {
          const id = setTimeout(() => {
            if (Notification.permission === 'granted') {
              new Notification(`${name} Prayer Reminder`, {
                body: `${name} is in ${msBefore} minutes.`,
                icon: '/remind.png',
              });
            }
            playSound();
            speak(`${name} prayer is in ${msBefore} minutes.`);
          }, delay);

          timersRef.current.push(id);

          console.log(
            `⏱ Local reminder scheduled for ${name} (in ${Math.round(
              delay / 60000,
            )} mins)`,
          );
        }
      });
    },
    [prefs.enabled, prefs.minutesBefore, playSound, speak],
  );

  // save location
  const saveLocation = (lat, lon, name) => {
    localStorage.setItem(
      STORED_LOCATION_KEY,
      JSON.stringify({ lat, lon, name, timestamp: Date.now() }),
    );
  };

  const handleLocationError = useCallback((err) => {
    setError('Location access failed. Please enter location manually.');
    setIsManualEntryNeeded(true);
    setLoading(false);
  }, []);

  // fetch prayer times
  const fetchPrayerTimes = useCallback(
    async (lat, lon, name = null, save = true) => {
      setLoading(true);
      setError('');
      try {
        const now = new Date();
        const response = await fetch(
          `${PRAYER_API_URL}/${now.getDate()}-${
            now.getMonth() + 1
          }-${now.getFullYear()}?latitude=${lat}&longitude=${lon}&method=2`,
        );
        const data = await response.json();
        if (data.code === 200 && data.status === 'OK') {
          const t = data.data.timings;
          setTimings(t);

          const zoneName =
            data.data.meta.timezone.split('/')[1]?.replace('_', ' ') ||
            'Fetched Location';
          const finalName = name || zoneName;
          setLocationName(finalName);

          const next = getNextPrayerWithRemainingTime(t);
          setNextPrayer(next);
          setTimeRemainingMs(next.remainingMs);

          if (save) saveLocation(lat, lon, finalName);
        } else {
          setError('Could not load prayer times.');
        }
      } catch {
        setError('Prayer API error.');
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  // reset location
  const handleResetLocation = async () => {
    if (!navigator.geolocation) {
      setError('Geolocation unsupported.');
      return;
    }

    setLoading(true);

    navigator.geolocation.getCurrentPosition(
      async (pos) => {
        const lat = pos.coords.latitude;
        const lon = pos.coords.longitude;

        let city = 'Unknown';
        try {
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${lat}&lon=${lon}`,
          );
          const json = await res.json();
          city =
            json.address.city ||
            json.address.town ||
            json.address.village ||
            json.address.state ||
            'Unknown';
        } catch {}

        await fetchPrayerTimes(lat, lon, city, true);
      },
      (err) => {
        setError('Location error.');
        setLoading(false);
      },
      { enableHighAccuracy: true, timeout: 10000 },
    );
  };

  // initial load
  useEffect(() => {
    if (hasAttemptedGeolocation.current) return;
    hasAttemptedGeolocation.current = true;

    const stored = localStorage.getItem(STORED_LOCATION_KEY);
    if (stored) {
      try {
        const { lat, lon, name } = JSON.parse(stored);
        if (lat && lon) {
          fetchPrayerTimes(lat, lon, name, false);
          return;
        }
      } catch {}
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const lat = pos.coords.latitude;
          const lon = pos.coords.longitude;
          fetchPrayerTimes(lat, lon, 'Live Location', true);
        },
        handleLocationError,
        { enableHighAccuracy: true, timeout: 10000 },
      );
    } else {
      handleLocationError({ message: 'No geolocation' });
    }
  }, [fetchPrayerTimes, handleLocationError]);

  // countdown
  useEffect(() => {
    if (!timeRemainingMs) return;

    const id = setInterval(() => {
      setTimeRemainingMs((prev) => {
        const next = prev - 1000;
        if (next <= 0 && timings) {
          clearInterval(id);
          const n = getNextPrayerWithRemainingTime(timings);
          setNextPrayer(n);
          setTimeRemainingMs(n.remainingMs);
          return 0;
        }
        return next;
      });
    }, 1000);

    return () => clearInterval(id);
  }, [timeRemainingMs, timings]);

  // manual location
  const handleManualSubmit = () => {
    if (!manualInput.trim()) {
      setError('Please enter a valid location.');
      return;
    }
    fetchPrayerTimes(DEMO_LAT, DEMO_LON, manualInput, true);
    setIsManualEntryNeeded(false);
  };

  // schedule reminders
  useEffect(() => {
    scheduleReminders(timings);
    return () => {
      timersRef.current.forEach(clearTimeout);
    };
  }, [timings, prefs, scheduleReminders]);

  // UI starts here 👇 — only UI, no logic changed
  // --------------------------------------------------------------------------

  if (loading && !isManualEntryNeeded) {
    return (
      <div className='min-h-screen flex flex-col items-center justify-center bg-indigo-50 p-6'>
        <div className='animate-spin rounded-full h-12 w-12 border-4 border-indigo-500 border-t-transparent'></div>
        <p className='mt-4 text-indigo-700 font-medium'>
          Fetching location and prayer times...
        </p>
      </div>
    );
  }

  const prayerIcons = {
    Fajr: <HiCloud className='w-6 h-6 text-blue-400' />,
    Sunrise: <HiSun className='w-6 h-6 text-yellow-500' />,
    Dhuhr: <HiSun className='w-6 h-6 text-orange-500' />,
    Asr: <HiCloud className='w-6 h-6 text-gray-500' />,
    Maghrib: <HiMoon className='w-6 h-6 text-purple-600' />,
    Isha: <HiMoon className='w-6 h-6 text-blue-900' />,
  };

  const prayerOrder = ['Fajr', 'Sunrise', 'Dhuhr', 'Asr', 'Maghrib', 'Isha'];

  return (
    <div className='min-h-screen bg-gray-50 flex flex-col items-center py-8 px-2'>
      {/* Next Prayer section */}
      {timings && nextPrayer && !isManualEntryNeeded && (
        <section className='w-full max-w-xl px-2 space-y-6 flex flex-col items-center mb-10'>
          <h1
            className='text-2xl sm:text-4xl font-extrabold text-center
            bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-blue-700'
          >
            Your Daily Compass
          </h1>

          {/* Next Prayer Card */}
          <div className='relative w-full'>
            <div className='absolute -inset-1 bg-blue-200/20 blur-2xl rounded-3xl'></div>
            <div className='relative bg-gradient-to-b from-white to-blue-50 rounded-3xl shadow-md p-6 border border-blue-100'>
              <div className='flex justify-between items-start mb-4'>
                <div>
                  <p className='text-xs uppercase tracking-wider text-gray-500 font-semibold'>
                    Next Prayer
                  </p>
                  <p className='text-lg font-bold text-blue-700 mt-1'>
                    {nextPrayer.name}
                  </p>
                </div>
                <div className='text-right'>
                  <p className='text-[10px] uppercase tracking-wider text-gray-400 font-semibold'>
                    Time Remaining
                  </p>
                  <p className='text-base font-bold text-red-500'>
                    {formatTimeRemaining(timeRemainingMs)}
                  </p>
                </div>
              </div>

              <div className='flex items-end justify-between mt-4'>
                <span className='text-7xl font-extrabold text-blue-600'>
                  {nextPrayer.time}
                </span>
              </div>
            </div>
          </div>

          {/* Full Timings */}
          <div className='w-full bg-white p-5 rounded-3xl shadow-md border border-gray-100'>
            <h3 className='text-2xl font-bold text-gray-700 mb-4 border-b pb-2 flex items-center'>
              <HiClock className='w-5 h-5 mr-2 text-blue-500' />
              Today's Full Timings
            </h3>
            <div className='divide-y divide-gray-100'>
              {prayerOrder.map(
                (name) =>
                  timings[name] && (
                    <div
                      key={name}
                      className={`flex justify-between items-center py-3 px-3 rounded-xl ${
                        nextPrayer.name === name
                          ? 'bg-indigo-50 font-semibold border border-indigo-100'
                          : ''
                      }`}
                    >
                      <span className='flex items-center text-lg text-gray-700'>
                        {prayerIcons[name]}
                        <span className='ml-3'>{name}</span>
                      </span>
                      <span
                        className={`text-xl font-mono ${
                          nextPrayer.name === name
                            ? 'text-blue-600'
                            : 'text-gray-800'
                        }`}
                      >
                        {timings[name]}
                      </span>
                    </div>
                  ),
              )}
            </div>
          </div>
        </section>
      )}

      {/* Header / Buttons */}
      <header className='text-center w-full max-w-xl px-2 mb-8'>
        <p className='text-lg text-gray-800 mb-6 flex items-center justify-center font-medium'>
          <HiLocationMarker className='w-5 h-5 mr-2 text-blue-500' />
          <span className='text-gray-600'>Location:</span>
          <span className='font-extrabold text-blue-800 ml-1'>
            {locationName}
          </span>
        </p>

        <div className='flex flex-col items-center gap-4'>
          {/* Daily Check-in */}
          <button
            onClick={() => navigate('/sura-dashboard')}
            className='w-full flex items-center justify-center gap-2 px-5 py-2
              bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700
              text-white text-lg font-bold rounded-2xl shadow-lg transition-all'
          >
            Daily Check-In
            <HiArrowNarrowRight className='w-5 h-5' />
          </button>

          <div className='flex w-full gap-4'>
            {/* Location */}
            <button
              onClick={handleResetLocation}
              disabled={loading}
              className='w-1/2 flex items-center justify-center gap-2 px-3 py-2
                bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 
                text-white text-base font-bold rounded-2xl shadow-lg'
            >
              <HiLocationMarker className='w-5 h-5' />
              Location
            </button>

            {/* Qibla */}
            <button
              onClick={() => setIsQiblaOpen(true)}
              className='w-1/2 flex items-center justify-center gap-2 px-3 py-2
                bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500 
                text-white text-base font-bold rounded-2xl shadow-lg'
            >
              <FaKaaba className='w-5 h-5 rotate-180' />
              Qibla
            </button>
          </div>

          {/* Notification */}
          <button
            onClick={() => setIsSettingsOpen(true)}
            className='w-full flex items-center justify-center gap-2 px-5 py-2
              bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700
              text-white text-lg font-bold rounded-2xl shadow-lg'
          >
            Notification 🔔
          </button>
        </div>
      </header>

      <SettingsModal
        isOpen={isSettingsOpen}
        onClose={() => setIsSettingsOpen(false)}
        prefs={prefs}
        setPrefs={setPrefs}
        playSound={playSound}
        speak={speak}
      />

      {error && (
        <div className='bg-red-100 text-red-700 p-4 rounded-lg shadow-md w-full max-w-xl mb-6'>
          ⚠️ {error}
        </div>
      )}

      {/* Manual entry */}
      {isManualEntryNeeded && (
        <div className='w-full max-w-xl px-4 bg-white p-6 rounded-2xl shadow-xl mb-6'>
          <h3 className='text-2xl font-bold text-gray-700 mb-4'>
            <HiMap className='w-6 h-6 mr-2 inline text-indigo-500' />
            Enter Location Manually
          </h3>
          <p className='text-sm text-red-500 mb-4 font-semibold'>
            ⚠️ Location failed. Enter city manually.
          </p>
          <input
            className='w-full p-3 border rounded-lg'
            value={manualInput}
            onChange={(e) => setManualInput(e.target.value)}
            placeholder='City or Zip (e.g., London)'
          />
          <button
            onClick={handleManualSubmit}
            className='w-full px-6 py-2 bg-indigo-600 text-white font-semibold rounded-lg mt-3'
          >
            Get Prayer Times
          </button>
        </div>
      )}

      {/* Qibla */}
      <QiblaFinderModal
        isOpen={isQiblaOpen}
        onClose={() => setIsQiblaOpen(false)}
      />
    </div>
  );
}
